import {StatsStrategy} from "../statsStrategy";
import React from "react";
import {UserWithStats} from "../../UserWithStats";
import {TFunction} from "i18next";
import {StatDetailsIcon, StatIconType} from "../../../components/stats/userStats/statDetailsIcon";
import {Graph} from "../../../components/stats/userStats/graphBestScore/graph";
import {getRelativeTime} from "../../../utils";


export class StatsStrategyFastaily extends StatsStrategy {
    leftPart(t: TFunction<"translation", undefined>, playerStats: UserWithStats): React.ReactNode {
        if (playerStats === null) return <></>;

        const translateString = getRelativeTime(t, playerStats.dateBest)

        return <>
            <div className="flex gap-5">
                <div>
                    <p>{t("stats.rank-of-the-day")}</p>
                    <div className="flex h-6 items-center">
                        {
                            playerStats.rank === null ?
                                <p className="text-white-transparent">{t("stats.no-rank-yet")}</p>
                                :
                                <p>{`#${playerStats.rank}`}</p>
                        }
                    </div>
                </div>
            </div>

            {playerStats.positions !== undefined && <div className="h-44">
                <div>
                    <p>{t("stats.graph-of-ranks")}</p>
                    <p className="text-white-transparent">{t("stats.best-ranking") + ": " + translateString}</p>
                </div>

                <Graph
                    key={JSON.stringify(playerStats.positions)}
                    data={playerStats.positions}
                    label={t("stats.rank")}
                    reverseY={true}
                />
            </div>}
        </>;
    }

    rightPart(t: TFunction<"translation", undefined>, playerStats: UserWithStats): React.ReactNode {
        return <div className="flex flex-col gap-16">
            <div className="flex flex-wrap justify-center gap-6">
                {playerStats.avgPosition !== undefined &&
                    <StatDetailsIcon icon={StatIconType.MEAN_RANKING} data={playerStats.avgPosition} />}
                {playerStats.totalGames !== undefined &&
                    <StatDetailsIcon icon={StatIconType.GAMES_PLAYED} data={playerStats.totalGames}/>}
                {playerStats.totalWords !== undefined &&
                    <StatDetailsIcon icon={StatIconType.WORDS_TYPED} data={playerStats.totalWords}/>}
            </div>

            <div className="flex justify-center flex-col w-full gap-4">
                <p className="text-xl">{t("stats.history-of-the-20-last-games")}</p>
                {playerStats.positions !== undefined && <>
                    {playerStats.positions
                        .slice() // create a copy
                        .sort((a, b) => b.date.getTime() - a.date.getTime())
                        .map((position) => (
                            <div className="flex flex-wrap justify-around gap-5 p-5 w-full bg-deep-blue rounded-xl">
                                <div className="flex gap-3 items-center">
                                    <p>{position.score}</p>
                                    <img className={"h-4 content-center"} src={`/icons/ranking.svg`} alt={t("stats.rank") } title={t("stats.rank")}/>
                                </div>

                                <div className="flex gap-3 items-center">
                                    <p>{position.scoreUser}</p>
                                    <img className={"h-4 content-center"} src={`/icons/input.svg`} alt={t("stats.words-typed") } title={t("stats.words-typed")}/>
                                </div>

                                <div className="flex gap-3 items-center">
                                    <p>{position.topWords}</p>
                                    <img className={"h-4 content-center"} src={`/icons/trophy.svg`} alt={t("stats.top-words")} title={t("stats.top-words")}/>
                                </div>

                                <div className="flex gap-3 items-center">
                                    <p>{position.avgWords}</p>
                                    <img className={"h-4"} src={`/icons/graph.svg`} alt={t("stats.avg-words")} title={t("stats.avg-words")}/>
                                </div>

                                <div className="flex gap-3 items-center">
                                    <p>{position.totalPlayers}</p>
                                    <img className={"h-4"} src={`/icons/user-group.svg`} alt={t("stats.participants")} title={t("stats.participants")}/>
                                </div>

                                <div className="flex gap-3 items-center">
                                    <p>{t("global.date-dd-mm", {date: position.date})}</p>
                                    <img className={"h-4 content-center"} src={`/icons/calendar.svg`} alt={"date"}/>
                                </div>
                            </div>
                    ))}
                </>}
            </div>
        </div>
    }
}
